import gsap from 'gsap';
import { t } from '../i18n';
import type { Transitions } from '../scene/transitions';

/**
 * Branded ink intro: screen starts fully inked (transitions.cover()), the
 * MOSER wordmark fades in/out, then the ink dissolves to reveal the sphere.
 * Skippable with any pointerdown/keydown. Resolves when the reveal is done.
 */
export function playIntro(transitions: Transitions): Promise<void> {
  transitions.cover();

  const el = document.createElement('div');
  el.id = 'intro';
  el.innerHTML = `
    <span class="wordmark">MOSER</span>
    <span class="tagline"></span>`;
  el.querySelector('.tagline')!.textContent = t('tagline');
  document.body.appendChild(el);

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  return new Promise((resolve) => {
    let finished = false;

    const finish = async () => {
      if (finished) return;
      finished = true;
      window.removeEventListener('pointerdown', skip);
      window.removeEventListener('keydown', skip);
      tl.kill();
      el.remove();
      await transitions.dissolve(reduced ? 0 : 0.9);
      resolve();
    };
    const skip = () => void finish();

    window.addEventListener('pointerdown', skip);
    window.addEventListener('keydown', skip);

    const tl = gsap.timeline({ onComplete: () => void finish() });
    if (reduced) {
      el.classList.add('visible');
      tl.to({}, { duration: 0.8 }); // static hold, hard cut
    } else {
      tl.to(el, { opacity: 1, duration: 0.6 });
      tl.to({}, { duration: 1.2 }); // hold
      tl.to(el, { opacity: 0, duration: 0.5 });
    }
  });
}
